// extracted by mini-css-extract-plugin
export default {"text":"Sfourth_text__L2p1j","title":"Sfourth_title__zFNau","Sfourth_desc":"Sfourth_Sfourth_desc__-TP9k","Sfourth":"Sfourth_Sfourth__phaMP","wrap":"Sfourth_wrap__spl6q"};